export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 4_00.2cb3941f.jpg";